import URL from '@/http/article_stock/article';
export default {
  namespaced: true,
  state: {
    mode: 'tableau',
    articleTypes: [
      { id: 'produits', libelle: 'Produit' },
      { id: 'services', libelle: 'Service' },
    ],
    currentArticle: null,
    entrepots: [],
    unites: [],
    familles: [],
    ligneBudgetaires: [],
  },

  getters: {
    mode: (state) => state.mode,
    articleTypes: (state) => state.articleTypes,
    currentArticle: (state) => state.currentArticle,
    entrepots: (state) => state.entrepots,
    unites: (state) => state.unites,
    familles: (state) => state.familles,
    ligneBudgetaires: (state) => state.ligneBudgetaires,
  },

  mutations: {
    SET_MODE(state) {
      state.mode = state.mode === 'tableau' ? 'catalogue' : 'tableau';
    },
    SET_CURRENT_ARTICLE(state, payload) {
      state.currentArticle = payload;
    },

    SET_ENTREPOTS(state, payload) {
      state.entrepots = payload;
    },

    SET_UNITES(state, payload) {
      state.unites = payload;
    },

    SET_FAMILLES(state, payload) {
      state.familles = payload;
    },

    SET_LIGNE_BUDGETAIRES(state, payload) {
      state.ligneBudgetaires = payload;
    },
  },

  actions: {
    setMode({ commit }) {
      commit('SET_MODE');
    },
    setEntrepots({ commit }, payload) {
      commit('SET_ENTREPOTS', payload);
    },
    setUnites({ commit }, payload) {
      commit('SET_UNITES', payload);
    },
    setFamilles({ commit }, payload) {
      commit('SET_FAMILLES', payload);
    },
    setLigneBudgetaires({ commit }, payload) {
      commit('SET_LIGNE_BUDGETAIRES', payload);
    },
    setCurrentArticle({ commit }, payload) {
      commit('SET_CURRENT_ARTICLE', payload);
    },
    getArticle({ commit }, payload) {
      commit('SET_CURRENT_ARTICLE', null);

      if (payload.edit) {
        return window.axios
          .get(URL.ARTICLE + '/' + payload.id, { params: { edit: true } })
          .then((resp) => {
            commit('SET_CURRENT_ARTICLE', resp.data.article);
          })
          .catch(() => {
            commit('SET_CURRENT_ARTICLE', null);
          });
      } else {
        return window.axios
          .get(URL.ARTICLE + '/' + payload.id)
          .then((resp) => {
            commit('SET_CURRENT_ARTICLE', resp.data.article);
          })
          .catch(() => {
            commit('SET_CURRENT_ARTICLE', null);
          });
      }
    },
  },
};
